import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { LoggerService } from 'src/app/services/logger.service';
import { UserApiService } from '../../services/user-api.service';
import { PCTableOutputModel } from '../../models/pc-table-input-model';
import { ApiRequestModel } from 'src/app/models/api-request-model';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ChangePassword } from '../../models/change-password';

@Component({
  selector: 'app-change-password-modal',
  templateUrl: './change-password-modal.component.html',
  styleUrl: './change-password-modal.component.css',
})
export class ChangePasswordModalComponent {
  constructor(
    public logger: LoggerService,
    private modalService: NgbModal,
    private apiService: UserApiService
  ) {
    this.needOldPassword = false;
    this.componentData = new ChangePassword();
  }

  public componentData: ChangePassword;
  public loading: boolean = false;

  @Input() needOldPassword: boolean;
  @Input() userId: string | undefined;

  @Output() parentAction = new EventEmitter<PCTableOutputModel>();

  @ViewChild('modalContent') modalContent!: any;

  public checkValidation(): boolean {
    let isValid = true;
    if (this.needOldPassword == null) {
      this.needOldPassword = false;
    }

    if (this.needOldPassword) {
      if (
        this.componentData.oldPassword == null ||
        this.componentData.oldPassword == ''
      ) {
        this.componentData.oldPasswordErrorMessage = 'Required';
        isValid = false;
      } else if (this.componentData.oldPassword.length < 8) {
        this.componentData.oldPasswordErrorMessage = 'invalid_Length';
        isValid = false;
      } else {
        this.componentData.oldPasswordErrorMessage = undefined;
      }
    } else {
      this.componentData.oldPasswordErrorMessage = undefined;
    }

    if (
      this.componentData.newPassword == null ||
      this.componentData.newPassword == ''
    ) {
      this.componentData.newPasswordErrorMessage = 'Required';
      isValid = false;
    } else if (this.componentData.newPassword.length < 8) {
      this.componentData.newPasswordErrorMessage = 'invalid_Length';
      isValid = false;
    } else {
      this.componentData.newPasswordErrorMessage = undefined;
    }

    if (
      this.componentData.confirmPassword == null ||
      this.componentData.confirmPassword == ''
    ) {
      this.componentData.confirmPasswordErrorMessage = 'Required';
      isValid = false;
    } else if (this.componentData.confirmPassword.length < 8) {
      this.componentData.confirmPasswordErrorMessage = 'invalid_Length';
      isValid = false;
    } else if (
      this.componentData.confirmPassword != this.componentData.newPassword
    ) {
      this.componentData.confirmPasswordErrorMessage =
        'Confirm_Password_Not_Match';
      isValid = false;
    } else {
      this.componentData.confirmPasswordErrorMessage = undefined;
    }

    if(this.userId==null){
      this.componentData.confirmPassword='Unknown';
      isValid=false;
    }

    return isValid;
  }

  public onSubmit() {
    if (!this.checkValidation()) {
      return;
    }
    try {
      this.loading = true;
      let url = `User/ChangePassword`;

      const backendJson = {
        oldPassword: '',
        newPassword: this.componentData.newPassword,
        userId: this.userId,
      };

      if (
        !this.apiService.tokenValidation(new ApiRequestModel(url, backendJson))
      ) {
        return;
      }

      this.apiService
        .patchItem(new ApiRequestModel(url, backendJson))
        .subscribe(
          (result) => {
            this.logger.addResponseLog(url, result, `Change Password`);
            if (result.succeeded) {
              this.parentAction.next(new PCTableOutputModel('Successed', null));
              this.loading = false;
            } else {
              this.logger.addBackEndMessage(result);
            }
            this.loading = false;
          },
          (error) => {
            this.apiService.AddErrorLog(error);
            this.loading = false;
          },
          () => {
            this.loading = false;
          }
        );
    } catch (e) {
      this.logger.addException(e, true);
      this.loading = false;
    }
  }

  public openModal() {
    try {
      this.modalService
        .open(this.modalContent, { ariaLabelledBy: 'modal-basic-title' })
        .result.then(
          (result) => {
            if (result == 'Save click') {
              // this.callParent('Save', this.thisValue);
            }

            // this.callParent('Close', null);
          },
          (reason) => {
            // this.callParent('Close', null);
          }
        );
    } catch (error) {
      this.logger.addException(error, false);
    }
  }
}
